import { createValidator, requiredRichText, richTextMaxLength } from 'util/validation'

import AtestadoModel from '../components/model-atestado'

export const atestadoEmBrancoFormValidator = createValidator<AtestadoModel>({
  descricao: [requiredRichText, richTextMaxLength(4000)],
})
